import React, { useEffect, useMemo } from "react";
import CustomReactTable from "../../../components/ReactTable/CustomReactTable";
import { useDispatch, useSelector } from "react-redux";
import {
  editBrand,
  getAllBrands,
  getManufacturers,
  patchEditBrandModal,
} from "../../../redux/CarsManagement/Brands/brandsSlice";
import { Controller, useForm } from "react-hook-form";
import { NavLink } from "react-router-dom";
import StatusSelect from "../../../components/CustomSelect/StatusSelect";
import MaintenanceSelect from "../../../components/CustomSelect/MaintenanceSelect";
import CustomInput from "../../../components/CustomInput/CustomInput";
import Select from "react-select";

function BrandsGrid() {
  const dispatch = useDispatch();

  const {
    allBrands,
    editBrandModalValues,
    isLoading,
    addOrEditResult,
    manufacturers,
  } = useSelector((state) => state.brands);

  const {
    formState: { errors, isValid, isDirty },
    handleSubmit,
    reset,
    control,
    setValue,
  } = useForm({
    defaultValues: {
      id: null,
      manufacturer: null,
      nameAr: "",
      nameEn: "",
      order: "",
      status: false,
      viewinmaintenance: false,
    },
  });

  useEffect(() => {
    dispatch(getAllBrands());
    dispatch(getManufacturers());
  }, [dispatch]);

  useEffect(() => {
    if (editBrandModalValues?.id) {
      reset(editBrandModalValues);
    }
  }, [editBrandModalValues, reset]);

  const manufacturerOptions = useMemo(() => {
    return (manufacturers || []).map((m) => ({
      value: m.manufacturerName1,
      label: `${m.manufacturerName1} - ${m.manufacturerName2}`,
      nameEn: m.manufacturerName1,
      nameAr: m.manufacturerName2,
    }));
  }, [manufacturers]);

  const handleBrandModalValues = (row) => {
    const payload = {
      id: row.id,
      manufacturer: row.nameEn,
      nameAr: row.nameAr,
      nameEn: row.nameEn,
      order: row.order,
      status: row.status,
      viewinmaintenance: row.viewinmaintenance,
    };

    dispatch(patchEditBrandModal(payload));
    reset(payload);
  };

  const handleEditBrand = (data) => {
    dispatch(
      editBrand({
        id: data.id,
        nameAr: data.nameAr,
        nameEn: data.nameEn,
        order: data.order,
        status: data.status,
        viewinmaintenance: data.viewinmaintenance,
      })
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "الإسم",
        accessor: "nameAr",
      },
      {
        Header: "النوع",
        Cell: ({ row }) => (
          <NavLink
            className="uk-button uk-button-link uk-border-rounded uk-text-secondary uk-text-bold"
            to="/Brands/BrandTypes"
            state={{
              id: row.original.id,
              brandName: row.original.nameAr,
            }}
          >
            عرض
          </NavLink>
        ),
      },
      {
        Header: "الحالة",
        accessor: "status",
        Cell: ({ row }) =>
          row.original.status ? (
            <span className="uk-text-success" uk-icon="check"></span>
          ) : (
            <span className="uk-text-danger" uk-icon="close"></span>
          ),
      },
      {
        Header: "الترتيب",
        accessor: "order",
      },
      {
        Header: "عرض في الصيانة",
        accessor: "viewinmaintenance",
        Cell: ({ row }) =>
          row.original.viewinmaintenance ? (
            <span className="uk-text-success" uk-icon="check"></span>
          ) : (
            <span className="uk-text-danger" uk-icon="close"></span>
          ),
      },
      {
        Header: "الإجراء",
        Cell: ({ row }) => (
          <div className="actions uk-flex uk-flex-center uk-flex-middle">
            <button
              uk-tooltip="تعديل"
              className="uk-icon-button"
              uk-icon="pencil"
              uk-toggle="target: #editBrandModal"
              onClick={() => handleBrandModalValues(row.original)}
            />

            <button
              uk-tooltip="حذف"
              className="uk-icon-button uk-margin-small-right"
              uk-icon="trash"
              //onClick={() => handleDeleteBrand(row.original.id)}
            />
          </div>

          
        ),
      },
    ],
    []
  );

  return (
    <>
      {/* EDIT MODAL */}
      <div id="ModalOfEditBrand">
        <div
          id="editBrandModal"
          uk-modal="bg-close: false"
          container="#ModalOfEditBrand"
        >
          <div className="uk-modal-dialog">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close=""
            />

            

            <div className="uk-modal-header uk-text-center">
              <h2 className="uk-modal-title">تعديل</h2>
            </div>


            <div className="uk-modal-body">
              <form className="uk-grid-small uk-child-width-1-2" uk-grid="">
                
                {/* Manufacturer Select */}
                <div>
                  <label className="uk-form-label uk-text-bold">المصنع</label>

                  <Controller
                    name="manufacturer"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={manufacturerOptions}
                        isSearchable
                        placeholder="ابحث عن المصنع"
                        value={
                          manufacturerOptions.find(
                            (x) => x.value === field.value
                          ) || null
                        }
                        onChange={(selected) => {
                          field.onChange(selected.value);
                          setValue("nameAr", selected.nameAr);
                          setValue("nameEn", selected.nameEn);
                        }}
                      />
                    )}
                  />
                </div>

                {/* Arabic */}
                <div>
                  <label className="uk-form-label">الإسم بالعربي</label>
                  <CustomInput control={control} name="nameAr" />
                </div>

                {/* English */}
                <div>
                  <label className="uk-form-label">الإسم بالإنجليزي</label>
                  <CustomInput control={control} name="nameEn" />
                </div>

                {/* Order */}
                <div>
                  <label className="uk-form-label">الترتيب</label>
                  <CustomInput
                    control={control}
                    name="order"
                    type="number"
                  />
                </div>

                {/* Status */}
                <div>
                  <label className="uk-form-label">الحالة</label>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <StatusSelect field={field} />
                    )}
                  />
                </div>

                {/* Maintenance */}
                <div>
                  <label className="uk-form-label">الصيانة</label>
                  <Controller
                    name="viewinmaintenance"
                    control={control}
                    render={({ field }) => (
                      <MaintenanceSelect field={field} />
                    )}
                  />
                </div>
              </form>
            </div>

            <div className="uk-modal-footer uk-text-left">
              <button
                className="uk-button uk-button-primary uk-border-rounded"
                disabled={!isDirty}
                onClick={handleSubmit(handleEditBrand)}
              >
                تعديل
              </button>
            </div>

            
          </div>
        </div>
      </div>

      {/* TABLE */}
      <CustomReactTable
        data={allBrands}
        columns={columns}
        isLoading={isLoading}
      />
    </>
  );
}

export default BrandsGrid;